import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ModalController } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { PopoverController } from 'ionic-angular';
import { PopoverPage } from '../popover/popover';
import { KlmrTimesheetCreateAddPage } from '../klmr-timesheet-create-add/klmr-timesheet-create-add';
import { getScrollData } from 'ionic-angular/umd/components/input/input';
import { SearchPage } from '../search/search';

@IonicPage()
@Component({
  selector: 'page-klmr-timesheet-approvals',
  templateUrl: 'klmr-timesheet-approvals.html',
})
export class KlmrTimesheetApprovalsPage {
  timeSheetList: any = [];
  actiivityCodeList: any = [];
  allFleetList: any = [];
  actionAllowed:boolean = false;
  selectedFilter = "All"
  constructor(public popoverCtrl: PopoverController, public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider,public modalController:ModalController) {
  }
  ionViewDidLoad() {
    this.getScrollData();
  }


  async getScrollData(){
    this.getPermission();
    this.getActivityCodeList();
    this.getTimeSheetData();
    this.gettimeSheetList();
  }

  async getActivityCodeList() {
    this.actiivityCodeList = [];
    let formData: FormData = new FormData();
    formData.append("method_name","activity_code");
    return this.api.post("/prestart/Activity_code", false,formData)
      .then((result: any) => {
        console.log("result", result);
        if (result.status) {
          
          this.actiivityCodeList = result.result;
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      });
  }

  getCodeName(id){
    let code = "";
    let index = this.actiivityCodeList.findIndex(list_ => list_['id'] == id);
      if(index != -1){
        code = this.actiivityCodeList[index].code;
      }
    return code
  }


  async getTimeSheetData() {
    let formData: FormData = new FormData();
    formData.append("method_name", "search_job_list_in_approver_list");
    this.api.post(`/prestart/timesheet/approver`, true, formData)
      .then((result: any) => {
        console.log("result", result);
      this.allFleetList = result.result.result;

      }, err => {
        console.log("err", err);
        this.utiltiy.toaster(err.error.message);
      });
  }

  async createData(list, key, value) {
    list.forEach(element => {
      element.key = element[key];
      element.value = element[value];
    });

    return [...[{"key":"All","value":"All"}],...list];
  }

  async openModalForSearch(list, title, key, value){
    list = await this.createData(list, key, value);
    const profileModal = this.modalController.create(SearchPage, { data: { list: list, header: title } }, { cssClass: 'managers', enableBackdropDismiss: true });
    profileModal.onDidDismiss(data => {
      console.log(data);
      if(data){
        this.selectedFilter = data.value;
        this.gettimeSheetList();
      }
    });
    profileModal.present();

  }
  


  async gettimeSheetList() {
    this.timeSheetList = [];
    this.utiltiy.startLoading();
    let userId = await this.utiltiy.getStorage("userId");
    let formData: FormData = new FormData();
    formData.append("method_name", "search_approver_list");
    if(this.selectedFilter == "All"){
      formData.append("search_job_no", "");

    }else{
      formData.append("search_job_no", this.selectedFilter);

    }
    this.api.post(`/prestart/timesheet/approver`, true, formData)
      .then((result: any) => {
        console.log("result", result);
        this.utiltiy.stopLoading();
        this.timeSheetList = result.result.result;

      }, err => {
        console.log("err", err);
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  formatAMPM(date) {
    date = date.split(":");
    var hours = date[0];
    var minutes = date[1];
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = date[0] + ':' + date[1];
    return strTime;
  }

  calculateTimeDifference(startTime, endTime) {
    if(startTime.length == 0 && endTime.length == 0){
      return "";
    }
    var start = startTime.split(":");
    var end = endTime.split(":");
    var startDate = new Date(0, 0, 0, start[0], start[1], 0);
    var endDate = new Date(0, 0, 0, end[0], end[1], 0);
    var diff = endDate.getTime() - startDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);

    if (hours < 0)
      hours = hours + 24;
    return (hours <= 9 ? "0" : "") + hours + ":" + (minutes <= 9 ? "0" : "") + minutes;
  }


  async acceptRejetc(id) {
    var options = {
      "title": 'Confirmation',
      "message": '',
      "approveText": 'Accept',
      "rejectText": 'Reject',
    };
    let status = await this.utiltiy.attentionDialog(options);
    if (status) {
      this.approveDisaaprove(id, "2", "");
    } else {
      let option = {
        "title": 'Comment',
        "approveText": 'send',
      };
      let comment = await this.utiltiy.inputDialog(option);
      this.approveDisaaprove(id, "4", comment);
      console.log("comment", comment);
    }
    console.log("status", status);
  }

  async approveDisaaprove(id, status, comment) {
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("timesheet_id", id);
    formData.append("status", status);
    formData.append("comments", comment);
    formData.append("method_name", "approver_timesheet_reject_approve_update_status");
    this.api.post(`/prestart/timesheet/approver`, true, formData)
      .then((result: any) => {
        console.log("result", result);
        this.utiltiy.stopLoading();
        this.gettimeSheetList();
      }, err => {
        console.log("err", err);
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  updateTimeSheet(prestart){
    this.navCtrl.push(KlmrTimesheetCreateAddPage, { param: prestart,copy:false,approval:true });
  }

  async getPermission(){
    this.actionAllowed =  await this.utiltiy.getPagePermission("klmr-timesheet-create-rw");
   }
}



// WEBPACK FOOTER //
// ./src/pages/klmr-timesheet-approvals/klmr-timesheet-approvals.ts